import { useMemo } from 'react'

import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { useStatsigExperiment } from '@src/experiments/statsig-integration'

export const useShowNewPdpUI = () => {
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.NEW_PDP_V1)
  return useMemo(() => experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.SHOW, [experimentBucket])
}
